<template>
    <section v-bind:id="NameLocation" class="group-of-companies section --group-of-companies" data-sectionThemeDark="true">
        
        
        <div class="summary-container" style="grid-column: 2/3;">
            <br>
<br>
<br>
<br>
            <h2 class="section-heading">Our Value Adders</h2>
            <p class="lead-text">Exceptional customer service isn't just a department-it's a mindset that drives every part of a business. From support teams to sales, each department works tirelessly to add value to everyday life, going above and beyond to create seamless, positive experiences that make a real difference for customers. Together, they transform service into something extraordinary.</p>
            
            <div class="companys-icons">
                <router-link to="/claimcentral/finance"><div class="finance"></div></router-link>
                <router-link to="/claimcentral/sales"><div class="sales"></div></router-link>

        </div>
        <div class="scroller--element">
            <scroller v-bind="ScrollerConfig" />
        </div>
<br>

<br>
            <h2 class="section-heading">Our Partners</h2>
            <p class="lead-text">We have partnered with Digital Path & Claim Central Africa to create shared experiences that are enhanced simultaneously across multiple devices, platforms and touchpoints.</p>
            <div class="companys-icons">
            <router-link to="/digitalpath"><div class="digital-path"></div></router-link>
            <a href="https://www.naked.insure/" target="_blank" rel="noopener noreferrer">
                <div class="naked-insurance"></div>
            </a>
            <!-- <router-link to="/theincentivecompany"><div class="tic"></div></router-link> -->
            <!-- <router-link to="/socialpath"><div class="social-path"></div></router-link> -->
            <router-link to="/claimcentral"><div class="claim-central"></div></router-link>
            <!-- <router-link to="/disabilityassist"><div class="disability-assist"></div></router-link> -->
                <!-- <div class="disability-assist"></div>  -->   
        </div>
        <br>
        <br>
        <div class="scroller--element">
            <scroller v-bind="ScrollerConfig" />
        </div>
        <br>
        </div>
        <!-- <h2 class="section-heading">Group of Companies</h2>
        <p class="lead-text">We have partnered with Digital Path and Claim Central Africa to create shared experiences that are enhanced simultaneously across multiple devices, platforms and touchpoints.</p> -->
       
        
        <SocialIconsMobile />
    </section>  
</template>
<script>
import Scroller from '@/components/ui/Scroller'
import SocialIconsMobile from '@/components/ui/SocialIconsMobile'

export default {
    name:"GroupOfCompanies", 
    components: {Scroller,SocialIconsMobile},
    props:["NameLocation"],
    data(){
        return {
            ScrollerConfig:{
                color:'#c6c6c6',
                animated:true,
                activeState:true,
                scrollTxt:false
            }
        }
    } 
}
</script>
<style>

</style>


